import type {
  TVShowsPlaylist,
  TvShowEpisode,
  TvShowSeasonWithEpisodes,
} from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'

import { isPaid } from '~/features/payment/lib/price-settings-fns'
import {
  extendMediaItemByLabelPriceTvShowEpisode,
  extendMediaItemByLabelPriceTvShowSeason,
} from '~/shared/tools'

export const formatSeasonEpisode = ({
  episode,
  t,
}: {
  episode: TvShowEpisode
  t: TFunction
}) => {
  const { labelPrice, rented, displayNumber } =
    extendMediaItemByLabelPriceTvShowEpisode(episode)

  return {
    ...episode,
    title: t('episode_number', { number: displayNumber }),
    labelPrice,
    rented,
    paid: isPaid(episode),
  }
}

export const formatSeason = ({
  season,
  t,
}: {
  season: TvShowSeasonWithEpisodes
  t: TFunction
}) => {
  const { labelPrice, rented } = extendMediaItemByLabelPriceTvShowSeason(season)
  const { episodes, episodesAmount } = season

  return {
    ...season,
    title: t('episode_count', {
      count: episodesAmount,
    }),
    labelPrice,
    rented,
    paid: isPaid(season),
    episodes: episodes.map((episode) => formatSeasonEpisode({ episode, t })),
  }
}

export const playlistFormatter = ({
  playlist,
  t,
}: {
  playlist: TVShowsPlaylist
  t: TFunction
}) => {
  if (playlist.seasonsWithEpisodes) {
    return {
      ...playlist,
      seasonsWithEpisodes: playlist?.seasonsWithEpisodes?.map((season) =>
        formatSeason({ season, t })
      ),
    }
  }

  if (playlist.episodes) {
    return {
      ...playlist,
      episodes: playlist?.episodes?.map((episode) =>
        formatSeasonEpisode({ episode, t })
      ),
    }
  }

  return playlist
}
